module.exports = __webpack_public_path__ + "static/media/1-mobile.a36de861.jpg";